// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"style_cardTitle__252BzYbIgVdZy5QTpazL_g"};